import { useFetch } from "../../hooks/useFetch";
import DashboardView, { DashboardConfig } from "./DashboardBtView2";
import PointList from "../../components/Points/PointList";
import { getDashboardConfig, getStoredOptions, StoredOption } from "../../api/data/reportToolsDrf";

const Switcher: React.FC = () => {

    const { data, loading, error } = useFetch<StoredOption[]>(getStoredOptions, [], 'point');

    // 2026-09-11 конфигурация отчетов с бекенда
    // {"reports": [{"id": 34, "type": "pivot"}, {"id": 133, "type": "gender"}, {"id": 132, "type": "age"}]}
    const {data: config, loading: configLoading, error: configError} = useFetch(getDashboardConfig, {});

    if (loading || configLoading) return <div>Loading Points, config...</div>;

    if (error) return <div>Error: {error.message}</div>;
    if (configError) return <div>Error: {configError.message}</div>;

    const dashboardConfig: DashboardConfig = {
      pivot: -1,
      gender: -1,
      age: -1,
    }
    config.reports.map((item: any)=>{
      if(item.type === 'pivot') dashboardConfig.pivot = item.id;
      if(item.type === 'gender') dashboardConfig.gender = item.id;
      if(item.type === 'age') dashboardConfig.age = item.id;
    })
    return (data.length > 0 &&
      dashboardConfig.pivot != -1 &&
      dashboardConfig.gender != -1 &&
      dashboardConfig.age != -1
    ) ? <DashboardView pointsVL={data} dashboardConfig={dashboardConfig}/> : <PointList />;
};

export default Switcher;